export default {"src":"https://static.jusbr.com/web/auth/_next/static/media/facebook.dd1a606e.svg","height":14222,"width":14222,"blurWidth":0,"blurHeight":0};